module.exports = __webpack_public_path__ + "static/media/helados.52cdca3e.jpg";